module.exports = __webpack_public_path__ + "img/DE01791.c6350b2a.png";